import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationLanguages } from 'src/app/enums/lang';

@Component({
  selector: 'app-home-cover',
  templateUrl: './cover.component.html',
  styleUrls: ['./cover.component.scss'],
})
export class CoverComponent implements OnInit {
  ApplicationLanguages = ApplicationLanguages;
  @Input() currentLang: string =
    localStorage.getItem('lang') || ApplicationLanguages.Ar;

  get imgLink() {
    return (
      '/assets/images/home/cover/orders-and-users-' +
      (this.currentLang === ApplicationLanguages.En ? 'en.svg' : 'ar.svg')
    );
  }
  constructor(protected translate: TranslateService) {}

  ngOnInit(): void {}
}
